import { Button } from '@flippingbook/web.react-kit/dist/Button';
import { L10n } from '@flippingbook/web.react-kit/dist/L10n';
import { Paper } from '@flippingbook/web.react-kit/dist/Paper';
import { Link } from 'react-router-dom';

import { useRestoreUpdatePage } from '@/hooks/useRestoreUpdatePage';
import { loc } from '@/localization';
import { UserPasswordField } from '@/site/components/UserPasswordField';

import { b, e } from '../Login/style.css';

export function UpdatePage() {
    const {
        loginUrl,
        errors,
        isSubmitting,
        isSubmitted,
        validationRules,
        register,
        triggerValidation,
        watch,
        onFormSubmit,
    } = useRestoreUpdatePage();

    return (
        <div className={b.name}>
            <Paper
                className={e.card}
                radius="large"
            >
                <h1 className={e.title}>{loc.Login.ChangePasswordTitle}</h1>
                <form
                    className={e.form}
                    onSubmit={onFormSubmit}
                    noValidate
                >
                    <UserPasswordField
                        className={e.emailField}
                        name="password"
                        placeholder={loc.Login.PasswordConfirmation}
                        register={register}
                        errors={errors}
                        triggerValidation={triggerValidation}
                        validationRules={validationRules}
                        readOnly={isSubmitting}
                        isSubmitted={isSubmitted}
                        watch={watch}
                    />
                    <div className={e.buttons}>
                        <Button
                            className={e.submitButton}
                            type="submit"
                            theme="green"
                            size="large"
                            progress={isSubmitting}
                            disabled={isSubmitting}
                        >
                            {loc.Login.DoChangePassword}
                        </Button>
                    </div>
                </form>
                <div className={e.footer}>
                    <p>
                        <L10n
                            text={loc.Login.RestoreAlreadyHaveAnAccount}
                            replaces={[
                                [
                                    '{doLogin}',
                                    <Link
                                        to={loginUrl}
                                        reloadDocument
                                    >
                                        {loc.Login.DoLogin.toLowerCase()}
                                    </Link>,
                                ],
                            ]}
                        />
                    </p>
                </div>
            </Paper>
        </div>
    );
}
